import { Button, Grid } from "@mui/material";
import deleteConfirmIcon from "../../assets/Images/popupDeleteIcon.svg";
import globalStyles from "../../Styles/ComponentStyles/GlobalDeletePopup/GlobalDeletePopup.module.scss";

interface DeletePopupProps {
    popupTitle?: string;
    popupDescription: string;
    handleClose: () => void;
    onDelete: () => void;
}

export default function GlobalDeletePopup({ popupDescription, handleClose, onDelete }: DeletePopupProps) {
    return (
        <Grid container
            className={globalStyles.demo}
            direction={"column"}
            textAlign={"center"}
            justifyContent={"center"}
            sx={{ padding: "20px" }}  // Added padding for better spacing
        >
            <Grid container direction={"column"} alignItems={"center"} gap={3}>
                <Grid item>
                    <img width={"100px"} height={"100px"} src={deleteConfirmIcon} alt="deleteIcon" />
                </Grid>
                <Grid item>
                    <span className={globalStyles.deleteDescription}>{popupDescription}</span>
                </Grid>
                <Grid item>
                    <Grid container gap={3} justifyContent="center">
                        <Grid item>
                            <Button className={globalStyles.deleteNoBtnStyle} onClick={handleClose}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button className={globalStyles.deleteYesBtnStyle} onClick={onDelete}>
                                Delete
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}